<!--  -->
<template>
  <div class="shell">
    <div class="sourceTop">
      <!-- <div class="desc">
          <p>
            如果在其他地方引用了资源库图片，则删除资源库图片后，图片将失效无法显示。
          </p>
          <p class="record">共有{{ total }}条记录</p>
        </div> -->
      <div class="btns">
        <el-upload
          class="avatar-uploader"
          accept="image/jpeg,image/gif,image/png"
          action="https://www.58zltc.com/wechat/agent.image/upload"
          :show-file-list="false"
          :on-success="handleLogoSuccess"
          :before-upload="beforeLogoUpload"
          :data="imageData"
          name="image"
        >
          <el-button size="small" type="primary">上传</el-button>
        </el-upload>
        <!-- <el-dropdown>
            <el-button size="small">删除</el-button>

            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item>删除全部</el-dropdown-item>
              <el-dropdown-item>删除选中</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown> -->
      </div>
    </div>
    <div class="sourceContainer">
      <ul class="sourceList" v-if="dataList.length">
        <li v-for="(item, index) in dataList" :key="index" @click="chose(item)">
          <div class="imgBox noCheck">
            <img :src="item.url" class="img" style="display: block;" />
            <div class="imgShade" v-if="choseImg == item.id">
              <img src="@public/img/checkImg.png" alt="" />
            </div>
          </div>
          <p class="fileName ellipsis">1586357282430.jpeg</p>
        </li>
      </ul>
      <div class="null" v-else>空空如也~</div>
      <div class="page">
        <el-pagination
          layout="prev, pager, next, total, jumper"
          :current-page="page"
          :total="total"
          :page-size="10"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { materialAll, materialList } from "@/api/push";
export default {
  computed: {
    ...mapGetters(["token", "app_id"])
  },
  data() {
    return {
      page: 1,
      total: 0,
      imageData: {},
      dataList: [],
      choseImg: "0"
    };
  },

  components: {},
  created() {
    this.imageData = {
      token: this.token,
      app_id: this.app_id
    };
    this.getList();
  },
  methods: {
    chose(item) {
      this.choseImg = item.id;
      this.$emit("choseImgValue", item);
    },
    handleCurrentChange(p) {
      this.page = p;
      this.getList();
    },
    getList() {
      let data = {
        token: this.token,
        app_id: this.app_id,
        page: this.page
      };
      materialList(data).then(res => {
        // dataList
        this.dataList = res.data.data;
        this.total = res.data.total;
        console.log(res);
      });
    },
    handleLogoSuccess(res, file) {
      if (res.code == 200) {
        this.getList();
        this.$message.success(res.msg);
      } else {
        this.$message.warning(res.msg);
      }
    },
    beforeLogoUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error("上传Logo图片大小不能超过 2MB!");
      }
      return isLt2M;
    }
  }
};
</script>
<style lang="scss" scoped>
.shell {
  width: 100%;
  padding: 20px;

  border-top: 1px solid #ccc;
  border-bottom: 1px solid #ccc;
}
.sourceContainer {
  width: 100%;
  height: auto;
  background: #f9fafb;
  border-radius: 5px;

  padding: 26px 20px 26px 20px;
  border: 1px solid #eee;

  // -webkit-box-shadow: 0 1px 6px 0 rgba(0, 0, 0, 0.05);
  // box-shadow: 0 1px 6px 0 rgba(0, 0, 0, 0.05);
  border-radius: 4px;
}
.sourceTop {
  text-align: right;
  margin-bottom: 20px;
  .el-button {
    // padding: 6px 26px;
    width: 102px;
  }
}
.sourceContainer .sourceList {
  margin-top: 10px;
  display: flex;
  flex-wrap: wrap;
}
.sourceContainer .sourceList li .imgBox {
  width: 100px;
  height: 100px;
  margin: 10px;
  border: 1px solid #eeeef1;
  border-radius: 4px;
  cursor: pointer;
  position: relative;
  box-sizing: border-box;
  .img {
    width: 100%;
  }
  // 选中状态
  .imgShade {
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 4px;
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      width: 32px;
    }
  }
}
// .sourceContainer .sourceList .fileName {
//   width: 100px;
//   line-height: 20px;
//   margin-top: 8px;
//   white-space: nowrap;
//   text-overflow: ellipsis;
//   overflow: hidden;
//   table-layout: fixed;
// }
// 分頁
.sourceContainer .page {
  padding: 10px 0;
  text-align: right;
}
//
.null {
  color: #979ba0;
  text-align: center;
  line-height: 30px;
}
</style>
